export default "__VITE_ASSET__28de0d93__"